<div class="fx_modal_container" appModalDrag>
	<form dw-form [formGroup]="myform" class="fx_form_content">
		<div class="fx_form_group">

			<div dw-row style="min-height: 200px;" dwGutter="8">
				<span style="position: absolute;left: 36%;font-size: 14px;font-weight: 600;">支付金额：¥ {{amt}}</span>
				<!-- 二维码 -->
				<div class="print-code"
					style="width: 300px;display: inline-block;margin-left: 25%;float:left;margin-top: 30px;">
					<qr-code [size]="300" [value]="qrCode"></qr-code>
				</div>

			</div>

		</div>
	</form>
</div>